import type { MeTenant } from './api/types';
import { pilots } from './labels/labels';

/** Human name for a tenant: registry description, else the pilot label of its group, else its code. */
export function tenantDisplayName(tenant: MeTenant): string {
  if (tenant.description?.trim()) return tenant.description.trim();
  if (tenant.tenantGroup && pilots[tenant.tenantGroup]) return pilots[tenant.tenantGroup].label;
  return tenant.tenantName;
}
